import React, { useEffect, useMemo, Fragment } from 'react';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Grid } from 'antd';
import { useRouter } from 'next/router';
import pathToRegexp from 'path-to-regexp';
import SiderMenu from 'src/components/SiderMenu';
import GlobalHeader from 'src/components/GlobalHeader';
import ErrorBoundary from 'src/components/ErrorBoundary';
import { appReadySelector, isInAppSelector, localeSelector } from 'src/selector/app';
import { menusSelector, currentUserSelector } from 'src/selector/user';
import { collapsedSelector } from 'src/selector/app';
import { actions as appActions, fetchRestaurantList } from 'src/actions/app';
import { loadMenus } from 'src/actions/rgUser';
import { fetchRestaurantGrouInfo } from 'src/actions/app';
import { restaurantGroupSelector } from 'src/selector/user';

import { getItemName } from 'src/utils/utils';
import styles from './basic.less';

const SmallLogo = `${process.env.ASSETS_PREFIX}/assets/logo_sm.png`;
const logo = `${process.env.ASSETS_PREFIX}/assets/logo.png`;

const { Content } = Layout;
const { useBreakpoint } = Grid;

const getPageTitle = (pathname = '/dashboard', locale, menus) => {
  const menu = menus.find(
    (menuItem) => (!!menuItem.path && pathToRegexp(menuItem.path).test(pathname)) || pathname.includes(menuItem.path)
  );

  if (menu) {
    return `POS-` + getItemName(menu, locale);
  }

  return 'POS';
};

const GroupLayoutAA = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const locale = useSelector(localeSelector);
  const { menus, loadingMenu } = useSelector(menusSelector);
  const { currentRgId } = useSelector(currentUserSelector);
  const isInApp = useSelector(isInAppSelector);
  const appReady = useSelector(appReadySelector);
  const collapsed = useSelector(collapsedSelector);
  const { isLoadRestaurantGroupInfoDone } = useSelector(restaurantGroupSelector);
  const { fixedSideBar = true, sideBarWidth = 260, fixHeader = true } = props;

  useEffect(() => {
    if (!appReady || !currentRgId) return;
    dispatch(fetchRestaurantList());
    dispatch(fetchRestaurantGrouInfo());
  }, [appReady, isInApp, currentRgId]);

  useEffect(() => {
    if (!appReady || !currentRgId || !isLoadRestaurantGroupInfoDone) return;
    dispatch(loadMenus());
  }, [appReady, isInApp, currentRgId, isLoadRestaurantGroupInfoDone]);

  const title = useMemo(() => {
    return getPageTitle(router.asPath, locale, menus);
  }, [router.asPath, locale, menus]);

  const handleMenuCollapse = () => {
    dispatch({
      type: appActions.changeLayoutCollapsed,
      payload: !collapsed,
    });
  };

  const layout = (
    <Layout>
      {/* 左侧导航栏 */}
      {!isInApp && (
        <SiderMenu
          logo={collapsed ? SmallLogo : logo}
          menuData={menus}
          loadingMenu={loadingMenu}
          isMobile={!screens.sm}
          onCollapse={handleMenuCollapse}
          collapsed={collapsed}
          theme="light"
          fixedSideBar={fixedSideBar}
          width={sideBarWidth}
        />
      )}
      <Layout style={{ minHeight: 'calc(100vh)', paddingTop: !isInApp && fixHeader ? 64 : 0 }}>
        {/* 顶部导航栏 */}
        {!isInApp && (
          <GlobalHeader
            isMobile={!screens.sm}
            fixedSideBar={fixedSideBar}
            sideBarWidth={sideBarWidth}
            fixHeader={fixHeader}
            collapsed={collapsed}
          />
        )}
        <Content className={styles.content}>
          <ErrorBoundary>{props.children}</ErrorBoundary>
        </Content>
      </Layout>
    </Layout>
  );

  return (
    <Fragment>
      <Head>
        <title>{title}</title>
      </Head>
      {layout}
    </Fragment>
  );
};

export default GroupLayoutAA;
